import styled from 'styled-components';
import PropTypes from 'prop-types';
import boxShadowGenerator from '@utils/boxShadowGenerator';

const BannerImage = styled.img`
  height: auto;
  width: 100%;
  border-radius: 8px;
  box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
`;

const GenericBanner = ({ block }) => {
  const data = block?.data[0];
  return (
    <a href={data.url} target="_blank" rel="noreferrer">
      <BannerImage src={data.img} alt="" />
    </a>
  );
};

export default GenericBanner;

GenericBanner.propTypes = {
  block: PropTypes.objectOf(PropTypes.any).isRequired
};
